
import Vue from 'vue'
import Vuex from 'vuex';
import axios from 'axios';
import {
    mapState
} from 'vuex'

export default Vue.extend({
    name: 'HomeView',
    data() {
        return {
            carouselImageList: [{
                    Id: '1',
                    ImageUrl: require('@/assets/images/carousel-images/1.png'),
                    Url: ''
                },
                {
                    Id: '2',
                    ImageUrl: require('@/assets/images/carousel-images/2.jpg'),
                    Url: ''
                },
                {
                    Id: '3',
                    ImageUrl: require('@/assets/images/carousel-images/3.jpg'),
                    Url: ''
                },
                {
                    Id: '4',
                    ImageUrl: require('@/assets/images/carousel-images/4.jpg'),
                    Url: 'https://planet-ring.com/detail/000022'
                },
                {
                    Id: '5',
                    ImageUrl: require('@/assets/images/carousel-images/5.png'),
                    Url: 'https://xhzgmodel.taobao.com/category-1734859915.htm?spm=a1z10.1-c.w5003-25094642583.1.43c72233xkKPp7&search=y&catName=EVA&scene=taobao_shop#bd'
                }
                
            ],
            bannerHeight: 100, //图片父容器的高度
            screenWidth: 0, //屏幕的宽度
        }
    },
    mounted() {
        this.$store.dispatch('getNewList');
        this.$store.dispatch('getProductList');

        this.screenWidth = window.innerWidth;
        this.setSize();
        window.onresize = () => {
            this.screenWidth = window.innerWidth;
            this.setSize();
        };
    },
    methods: {
        getItemPicLink(id){
            const imgLink = '/img/products-images/'+ id +'/list_pic.png';
            return imgLink;
        },
        goToNewsLink(link) {
            window.open(link);
        },
        setSize: function () {
            // 通过屏幕宽度(图片宽度)计算高度
            this.bannerHeight = 900 / 1920 * this.screenWidth;
        },
    },
    components: {},
    computed: {
        ...mapState(['newList', 'productList', 'currentLanguage']),
        currentNewsList() {
            if (this.newList) {
                // let currentNewsList = this.newList.filter(item => item.language === this.currentLanguage);
                let currentNewsList = this.newList;
                return currentNewsList;
            } else {
                return false;
            }

        },
        currentProductsList() {
            if (this.productList) {
                let currentProductsList = this.productList;
                return currentProductsList;
            } else {
                return false;
            }

        },
        currentLang() {
            return this.currentLanguage;
        }
    }
})
